var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEngagement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#4897EB;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.7,26.5c1.8-1.9,1.8-4.9,0-6.7c-1.8-1.9-4.7-1.9-6.5,0c-1.8,1.9-1.8,4.9,0,6.7C26,28.4,28.9,28.4,30.7,26.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.9,28.8c2.2,0,4-1.9,4-4.2s-1.8-4.2-4-4.2c-2.2,0-4,1.9-4,4.2S15.6,28.8,17.9,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.1,28.6c2.2-0.5,3.5-2.8,3-5s-2.7-3.6-4.9-3.1c-2.2,0.5-3.5,2.8-3,5C33.7,27.8,35.9,29.2,38.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.1,30.9c-1.1-1.2-2.4-1.6-2.9-1.6c-0.3,0.1-0.6,0.3-1.1,0.3c-0.4,0.1-0.7,0.1-1,0.1c-0.3,0-0.6-0.1-1-0.1 c-0.4-0.1-0.8-0.2-1.1-0.3c-0.4,0.1-1.2,0.3-2,0.8c-1.2-1.2-2.6-1.6-3.2-1.7c-0.3,0.1-0.8,0.3-1.2,0.4c-0.4,0.1-0.8,0.1-1.1,0.1 c-0.3,0-0.7-0.1-1.1-0.1c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5,0.1-1.9,0.5-3.1,1.7c-0.8-0.6-1.7-0.8-2-0.8c-0.3,0.1-0.6,0.3-1.1,0.3 c-0.4,0.1-0.7,0.1-1,0.1s-0.6-0.1-1-0.1c-0.4-0.1-0.8-0.2-1.1-0.3c-0.5,0.1-1.8,0.4-2.9,1.6c-1.3,1.4-1.5,3-1.5,3.8 c0,0.3,0.3,0.5,0.5,0.5h5.8h3h2.8h3.8h3.8h2.8h3h5.8c0.3,0,0.5-0.2,0.5-0.5C43.4,33.9,43.3,32.3,42.1,30.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEngagement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/engagement.f08363853411b3473ad042c8fc3a12e6.svg";